module.exports = __webpack_public_path__ + "img/grassi3.1bc65ce3.png";